<template>
  <v-row justify="start">
    <v-dialog
      v-model="d_up"
      persistent
      max-width="550px"
      scrollable
      @click:outside="$emit('close')"
      @keydown.esc="$emit('close')"
    >
      <v-card class="rounded_max hide_overflow" flat>
        <v-toolbar dense flat>
          <div class="d-flex">
            <v-icon class="mr-1">mdi-folder</v-icon>
            <h3>Required Document</h3>
          </div>
          <v-spacer></v-spacer>
          <v-btn fab x-small depressed @click="$emit('close')"
            ><v-icon small>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text class="px-2 pb-0">
          <v-container style="height: max-content">
            <div v-if="inventory">
              <div v-for="(item, i) in inventory" :key="i" class="mb-3">
                <div class="d-flex align-start">
                  <v-icon class="mr-2">mdi-circle-medium</v-icon>
                  <div>
                    <p class="mb-0 text-justify" v-html="item.title"></p>
                    <a
                      :href="item.content"
                      class="white-space: pre-wrap;"
                      target="_blank"
                    >
                      {{ item.content }}
                    </a>
                  </div>
                </div>
                <v-divider></v-divider>
              </div>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  components: {},
  name: "dialogUP",
  props: ["d_up", "type", "title", "inventory", "width"],
  methods: {
    closeAndFetch() {
      this.$emit("refetch");
      this.$emit("close");
    },
  },
};
</script>

<style>
</style>